module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/arrows-h-30dfc4cf6b705afa9476325e177ba237.svg";